import React, { useContext } from 'react'
import ClientsIcon from "../../../Assets/Images/Dashboard/Clients.svg"
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CoinIcon from "../../../Assets/Images/coin-icon1.png";
import { TokenContext } from '../../../Context/TokenContext';

export default function Summary({clientsCount}) {
  const navigate = useNavigate()
  const tokenCtx = useContext(TokenContext)
  return (
    <div className='summary'>
            <div className='box-container'>
              <p className="box-heading">Clients</p>
              <div className='box'>
                <div className='number'>
                  <img src={ClientsIcon} alt="Clients Icon" />
                  <p>{clientsCount} {clientsCount > 1 || clientsCount === 0 ? `clients` : `client`}</p>
                </div>
                <Button className='add-btn' onClick={() => {
                  navigate('/add-client')
                }}>
                  Add Clients
                </Button>
              </div>
            </div>
            <div className='box-container'>
              <p className="box-heading">Wallet</p>
              <div className='box'>
                <div className='number'>
                  <img src={CoinIcon} alt="Clients Icon" height={"26px"} width={"26px"}/>
                  
                  <p>{tokenCtx.selectedToken} tokens</p>
                </div>
                <Button className='add-btn' onClick={() => {
                  navigate('/tokens')
                }}>
                  Buy Tokens
                </Button>
              </div>
            </div>
          </div>
  )
}
